import { formatKey } from '../Utils/Functions';
import * as actions from './Actions';

const parseRole = (payload) => {
    return {
        roleId: payload.roleId,
        name: payload.name,
        title: formatKey(payload.name),
        type: payload.type,
        createdBy: payload.createdBy,
        createdAt: payload.createdAt,
        updatedAt: payload.updatedAt,
        permissions: payload.permissions || [],
        users: payload.users || [],
    };
};

export const rolesReducer = (state = [], action) => {
    switch (action.type) {
        case actions.INITIALIZE_ROLES:
            return action.payload.map(role => parseRole(role));

        case actions.ADD_ROLE:
            return [...state, parseRole(action.payload)];

        case actions.UPDATE_ROLE:
            return state.map(role =>
                role.roleId === action.payload.roleId ? parseRole(action.payload) : role
            );

        case actions.DELETE_ROLE:
            return state.filter(role => role.roleId !== action.roleId);
        
        case actions.ASSIGN_PERMISSIONS_TO_ROLE:
            return state.map(role =>
                role.roleId === action.payload.roleId ? { ...role, permissions: action.payload.permissions } : role
            );

        case actions.ASSIGN_ROLES_TO_USERS:
            return state.map(role =>
                role.roleId === action.payload.roleId ? { ...role, users: action.payload.users } : role
            );

        case actions.CLEAR_ROLES_LIST:
            return [];

        default:
            return state;
    }
};
